export default {
  pageTitle: {
    id: 'bo_seller.kyb.review.page_title',
    defaultMessage: 'KYB - Review and submit',
  },
  title: {
    id: 'bo_seller.kyb.review.title',
    defaultMessage: 'Review and submit',
  },
  description: {
    id: 'bo_seller.kyb.review.description',
    defaultMessage:
      'Review all details to make sure they are accurate and complete. Once you submit, your information will be processed for verification.',
  },
  submitButton: {
    id: 'bo_seller.kyb.review.submit_button',
    defaultMessage: 'Submit',
  },
  submitSuccessTitle: {
    id: 'bo_seller.kyb.review.submit_success_title',
    defaultMessage: 'Details submitted',
  },
  submitSuccessContent: {
    id: 'bo_seller.kyb.review.submit_success_content',
    defaultMessage: 'Nice work',
  },
  submitErrorTitle: {
    id: 'bo_seller.kyb.review.submit_error_title',
    defaultMessage: "Details weren't submitted",
  },
  submitErrorContent: {
    id: 'bo_seller.kyb.review.submit_error_content',
    defaultMessage: 'Please try again',
  },
  goBackButton: {
    id: 'bo_seller.kyb.review.go_back_button',
    defaultMessage: 'Back',
  },
} as const
